import { Box, Button, Icon, IconButton, TextField, Tooltip, Typography } from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'
import FileUploadDialog from 'components/FileUploadDialog/FileUploadDialog'
import React from 'react'
import { ITaxAnalysisReportParams, IUploadDocumentFile } from 'types'


type ParamsType = "load_tax"

interface Props {
    type: ParamsType | string
    disabled: boolean
    reportKey: string
    onChange: (key: string, value: any) => void
    params: ITaxAnalysisReportParams
    clearFiles: boolean
}

type TypeFile = 'AP' | 'AR' | null

const arrEq = (a: any[] = [], b: any[] = []) =>
  a.length === b.length && a.every((v, i) => v === b[i]);


const TaxAnalisysReportParams = (props: Props) => {
    const { disabled, params, reportKey, onChange, clearFiles } = props
    const [open, setOpen] = React.useState<boolean>(false)
    const [typeFile, setTypeFile] = React.useState<TypeFile>(null)
    const [file1, setFile1] = React.useState<File | null>(null)
    const [file2, setFile2] = React.useState<File | null>(null)

    // === NUEVO: estado del textarea ===
    const [textValue, setTextValue] = React.useState<string>('')

    // Parser: comas o saltos de línea -> lista de strings
    const terms = React.useMemo(() => {
        return textValue
            .split(/[\n,]/g)
            .map(s => s.trim())
            .filter(Boolean)
    }, [textValue])

    const existFileOne = React.useMemo(() => {
        return Boolean(file1)
    }, [file1])


    const hanldeClearFiles = () => {
        setFile1(null);
        setFile2(null);
        setTextValue('');

        const prev = (params as any)[reportKey] || {};
        const updated = {
            ...prev,
            terms: [],
            charges: []   // <<< AQUI vaciamos charges
        };
        onChange(reportKey, updated);
        console.debug("[TaxAnalisysReportParams] clear files & charges", updated);
    };

    React.useEffect(() => {
        if (clearFiles) {
            hanldeClearFiles()
        }
    }, [clearFiles])

    React.useEffect(() => {
        const prev = (params as any)[reportKey] || {};
        const seed: string[] = prev.charges || prev.terms || [];
        setTextValue(seed.join('\n'));
    }, [reportKey]); // intencional: no dependas de params entero

    // ⭐ ÚNICO efecto de sincronización hacia arriba, con guard de igualdad
    React.useEffect(() => {
        const prev = (params as any)[reportKey] || {};
        const prevTerms: string[] = prev.terms || [];
        const prevCharges: string[] = prev.charges || [];
        if (arrEq(prevTerms, terms) && arrEq(prevCharges, terms)) return;

        const updated = { ...prev, terms, charges: terms };
        onChange(reportKey, updated);
    }, [terms, reportKey]);
    const existFileTwo = React.useMemo(() => {
        return Boolean(file2)
    }, [file2])

    const uploadExelConciliationFile = (acceptedFiles: IUploadDocumentFile[]) => {
        try {
            const prev = (params as any)[reportKey] || {};
            if (typeFile === 'AP') {
                const file1 = acceptedFiles[0].file;
                onChange(reportKey, { ...prev, file1, charges: prev.charges || terms });
                setFile1(file1);
            } else if (typeFile === 'AR') {
                const file2 = acceptedFiles[0].file;
                onChange(reportKey, { ...prev, file2, charges: prev.charges || terms });
                setFile2(file2);
            }
        } catch (error) {
        }
    };

    const handleDeleteFile = (typeFile: TypeFile) => {
        const prev = (params as any)[reportKey] || {};
        const updatedParams = {
            ...prev,
            [typeFile === 'AP' ? 'file1' : 'file2']: null,
            charges: prev.charges || terms // conserva charges
        };
        if (typeFile === 'AP') setFile1(null); else setFile2(null);
        onChange(reportKey, updatedParams);
    };

    const canUpload = terms.length > 0 && !disabled

    return (
        <div className="w-full flex flex-wrap pt-4">
            {
                reportKey === "load_tax_exel" &&
                <Box className="ml-1.5 pt-2">
                    {
                        !disabled && (
                            <Alert
                                severity="warning"
                                icon={<Icon fontSize='inherit'>warning</Icon>}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    margin: '1rem 0',
                                    width: 550,
                                    padding: '0.75rem 1rem',
                                }}
                            >
                                <AlertTitle>Nota</AlertTitle>
                                Debe llenar la lista de ChargeCodes, luego seleccionar los dos archivos Excel de forma obligatoria.
                            </Alert>
                        )
                    }

                    <Box style={{ width: 550, marginBottom: 12 }}>
                        <TextField
                            label="Términos / Palabras (coma o salto de línea)"
                            variant="outlined"
                            fullWidth
                            multiline
                            value={textValue}
                            onChange={(e) => setTextValue(e.target.value)}
                            placeholder={`Ejemplos:\ncliente1, cliente2, cliente3\n\nO en líneas separadas:\ncliente1\ncliente2\ncliente3`}
                            helperText={`Se guardarán ${terms.length} término(s)`}
                        />
                    </Box>

                    <Box style={{ display: 'flex', gap: 7 }}>
                        {!existFileOne && (
                            <Button
                                disabled={!canUpload}
                                disableElevation
                                color="primary"
                                size="small"
                                variant="contained"
                                onClick={() => {
                                    setTypeFile('AP')
                                    setOpen(true)
                                }}
                                style={{ paddingLeft: "0.85rem", height: 35, width: 270 }}
                            >
                                {"Subir excel AP Charge"}
                                <Icon fontSize="small" className="ml-1">
                                    upload
                                </Icon>
                            </Button>
                        )}

                        {!existFileTwo && (
                            <Button
                                disabled={!canUpload}
                                disableElevation
                                color="primary"
                                size="small"
                                variant="contained"
                                onClick={() => {
                                    setTypeFile('AR')
                                    setOpen(true)
                                }}
                                style={{ paddingLeft: "0.85rem", height: 35, width: 270 }}
                            >
                                {"Subir excel AR Charge"}
                                <Icon fontSize="small" className="ml-1">
                                    upload
                                </Icon>
                            </Button>
                        )}
                    </Box>

                    <Box style={{
                        display: 'flex',
                        gap: 7,
                        paddingTop: 20,
                        width: 550,
                        flexDirection: 'column'
                    }}>
                        {existFileOne && (
                            <Box
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: 'space-between',
                                    padding: "0.5rem 1rem",
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                    backgroundColor: "#f5f5f5",
                                    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    style={{
                                        marginRight: "0.75rem",
                                        color: "#333",
                                    }}
                                >
                                    <strong>Archivo AP seleccionado:</strong> {file1!.name}
                                </Typography>
                                <IconButton
                                    size="small"
                                    onClick={() => handleDeleteFile('AP')}
                                    style={{ color: "#ff6b6b" }}
                                >
                                    <Tooltip title="Borrar Archivo">
                                        <Icon fontSize="small">close</Icon>
                                    </Tooltip>
                                </IconButton>
                            </Box>
                        )}

                        {existFileTwo && (
                            <Box
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: 'space-between',
                                    padding: "0.5rem 1rem",
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                    backgroundColor: "#f5f5f5",
                                    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    style={{
                                        marginRight: "0.75rem",
                                        color: "#333",
                                    }}
                                >
                                    <strong>Archivo AR seleccionado:</strong> {file2!.name}
                                </Typography>
                                <IconButton
                                    size="small"
                                    onClick={() => handleDeleteFile('AR')}
                                    style={{ color: "#ff6b6b" }}
                                >
                                    <Tooltip title="Borrar Archivo">
                                        <Icon fontSize="small">close</Icon>
                                    </Tooltip>
                                </IconButton>
                            </Box>
                        )}
                    </Box>
                    <FileUploadDialog
                        open={open}
                        onClose={() => setOpen(false)}
                        onAccept={(files) => uploadExelConciliationFile(files)}
                        singleFile
                        hideDescription
                        validateTaxAnalisys
                    />

                </Box>
            }

        </div>
    )
}

export default TaxAnalisysReportParams
